"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EngrainClient = void 0;
const axios_1 = __importDefault(require("axios"));
const constants_1 = require("./constants");
class EngrainClient {
    constructor(options) {
        const { apiKey, baseUrl } = options;
        this.axios = axios_1.default.create({
            baseURL: baseUrl || constants_1.ENGRAIN_API_BASE_URL,
            headers: {
                'API-KEY': apiKey,
                'Experimental-Flags': 'references',
            },
        });
    }
    getAssetByIntegration(integration) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.handledRequest({
                requestConfig: {
                    method: 'get',
                    url: `/assets/references?per-page=100&key=${integration}`,
                },
                errorIfEmpty: true,
                fallbackErrorMessage: 'Failed to find asset for property',
            });
        });
    }
    getMapsByAsset(assetId) {
        return __awaiter(this, void 0, void 0, function* () {
            const maps = yield this.handledRequest({
                requestConfig: {
                    method: 'get',
                    url: `/maps?asset=${assetId}`,
                },
                errorIfEmpty: true,
                fallbackErrorMessage: 'Failed to find map for property',
            });
            return maps.filter(m => !constants_1.DEPRECATED_MAP_STYLES.includes(m.style));
        });
    }
    getUnitReferencesByAsset(assetId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.handledRequest({
                requestConfig: {
                    method: 'get',
                    url: `/units/references?per-page=1000&asset=${assetId}`,
                },
                errorIfEmpty: true,
                fallbackErrorMessage: 'Failed to find unit references for property',
            });
        });
    }
    getUnitsByMap(mapId_1) {
        return __awaiter(this, arguments, void 0, function* (mapId, errorIfEmpty = true, perPage) {
            let url = `/maps/${mapId}/units`;
            if (typeof perPage === 'number') {
                url += `?per-page=${perPage}`;
            }
            return yield this.handledRequest({
                requestConfig: {
                    url,
                    method: 'get',
                },
                errorIfEmpty,
                fallbackErrorMessage: 'Failed to find units for map',
            });
        });
    }
    getFloorsByAsset(assetId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.handledRequest({
                requestConfig: {
                    method: 'get',
                    url: `/assets/${assetId}/floors`,
                },
                errorIfEmpty: false,
            });
        });
    }
    handledRequest(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const { requestConfig, errorIfEmpty, fallbackErrorMessage } = args;
            const response = yield this.paginatedRequest(requestConfig);
            if (response.status !== 0) {
                if (errorIfEmpty) {
                    throw new Error(fallbackErrorMessage);
                }
                else {
                    return [];
                }
            }
            if ('data' in response && response.data.length > 0) {
                return response.data;
            }
            if (errorIfEmpty) {
                throw new Error(fallbackErrorMessage);
            }
            else {
                return [];
            }
        });
    }
    paginatedRequest(requestConfig_1) {
        return __awaiter(this, arguments, void 0, function* (requestConfig, accResults = []) {
            var _a;
            try {
                const response = yield this.axios(requestConfig);
                if (response.status !== 200) {
                    return { status: -1, message: response.data };
                }
                const paging = response.data.paging;
                const data = response.data.data;
                const results = [...accResults, ...data];
                if (paging.next_url !== null) {
                    return this.paginatedRequest(paging.next_url, results);
                }
                return { status: 0, data: results };
            }
            catch (error) {
                const errorData = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data;
                const errorMessage = errorData ? errorData.message : 'Failed to make request';
                return {
                    status: -1,
                    message: errorMessage,
                };
            }
        });
    }
}
exports.EngrainClient = EngrainClient;
//# sourceMappingURL=EngrainClient.js.map